/**
 * App-local facility helpers derived from the shared single source of truth
 * (`@amzn/eclipse-ui-common/constants/facilities`).
 *
 * `ALL_FACILITY_CODES` was previously duplicated as a hard-coded
 * `["KMD", "KNY", "KCT"]` array in both itemService and supplierService. Deriving
 * it from the shared `FACILITIES` map keeps the multi-facility fallback lookups
 * in lock-step with the canonical facility list — add a facility in one place
 * and every cross-facility search picks it up automatically.
 */
import { FACILITIES } from "@amzn/eclipse-ui-common/constants/facilities"

/** Every known facility code (e.g. used for cross-facility fallback lookups). */
export const ALL_FACILITY_CODES: readonly string[] = Object.keys(FACILITIES)
